import { LoadablePaint } from '@confluence/loadable';

export const FolderContainerLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-FolderContainer" */ './FolderContainer.tsx'))
			.FolderContainer,
});
